import type ru from 'antd/es/date-picker/locale/ru_RU';

export const rangePickerLocale: typeof ru = {
  lang: {
    week: 'Неделя',
    locale: 'ru_RU',
    placeholder: '',
    rangePlaceholder: ['От', 'До'],
    today: 'Сегодня',
    now: 'Сейчас',
    backToToday: 'Вернуться к сегодня',
    ok: 'OK',
    clear: 'Очистить',
    month: 'Месяц',
    year: 'Год',
    timeSelect: 'Выберите время',
    dateSelect: 'Выберите дату',
    monthSelect: 'Выберите месяц',
    yearSelect: 'Выберите год',
    decadeSelect: 'Выберите декаду',
    yearFormat: 'YYYY',
    dateFormat: 'DD.MM.YYYY',
    dayFormat: 'DD',
    dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
    previousMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    previousYear: 'Предыдущий год',
    nextYear: 'Следующий год',
    previousDecade: 'Предыдущая декада',
    nextDecade: 'Следующая декада',
    previousCentury: 'Предыдущий век',
    nextCentury: 'Следующий век',
    shortMonths: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
  },
  timePickerLocale: {
    placeholder: 'Выберите время',
  },
  dateFormat: 'DD.MM.YYYY',
  dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
  weekFormat: 'YYYY-wo',
  monthFormat: 'MM.YYYY',
};
